import request from './request';

const application_info = {
	async getPersonalParticularByApplicationId(id) {
		const response = await request.get(`/app/personal-info/id?id=${id}`);
		return response;
	},
	async createPersonalParticular(body) {
		const response = await request.post('/app/personal-info', body);
		return response;
	},
	async updatePersonalParticular(id,body) {
		const response = await request.patch('/app/personal-info/', body);
		return response;
	}
};

export default application_info;